function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m459.406 132.927-128.533-128.533c-2.813-2.813-6.628-4.394-10.606-4.394h-216.9c-30.419 0-55.167 24.748-55.167 55.167v401.666c0 30.419 24.748 55.167 55.166 55.167h305.267c30.419 0 55.167-24.748 55.167-55.167v-313.3c0-3.978-1.581-7.793-4.394-10.606zm-124.139-81.714 77.32 77.32h-52.154c-13.876 0-25.166-11.29-25.166-25.166zm73.366 430.787h-305.267c-13.876 0-25.166-11.29-25.166-25.167v-401.666c0-13.877 11.29-25.167 25.166-25.167h201.9v73.367c0 30.418 24.748 55.166 55.166 55.166h73.368v298.3c0 13.877-11.29 25.167-25.167 25.167z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m384.533 417.732h-257.066c-8.284 0-15 6.716-15 15s6.716 15 15 15h257.066c8.284 0 15-6.716 15-15s-6.716-15-15-15z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m384.533 353.467h-257.066c-8.284 0-15 6.716-15 15s6.716 15 15 15h257.066c8.284 0 15-6.716 15-15s-6.716-15-15-15z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m384.533 289.199h-257.066c-8.284 0-15 6.716-15 15s6.716 15 15 15h257.066c8.284 0 15-6.716 15-15s-6.716-15-15-15z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m127.467 254.934h192.8c8.284 0 15-6.716 15-15s-6.716-15-15-15h-192.8c-8.284 0-15 6.716-15 15s6.716 15 15 15z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m127.467 190.666h96.399c8.284 0 15-6.716 15-15v-96.399c0-8.284-6.716-15-15-15h-96.399c-8.284 0-15 6.716-15 15v96.399c0 8.284 6.716 15 15 15zm15-96.399h66.399v66.399h-66.399z"
});

var SvgCv = function SvgCv(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCv, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cv.cd3f0603.svg";
export { ForwardRef as ReactComponent };